import { useTranslation } from 'react-i18next'

import { CompareSegmentsGroup } from '@/components/quick-study-results/CompareSegmentsPicker'
import { Text } from '@/components/ui/Text'
import { cn } from '@/lib/utils'

import { suggestTwinTestCuts } from './twinTestCutMapping'

interface TwinTestCutSuggestionsProps {
  groups: Array<CompareSegmentsGroup>
  selectedSegmentBy: string | null
  onChange: (segmentBy: string) => void
}

export function TwinTestCutSuggestions(props: TwinTestCutSuggestionsProps) {
  const { groups, selectedSegmentBy, onChange } = props

  const { t } = useTranslation('app')

  const suggestions = suggestTwinTestCuts(groups)

  if (suggestions.length === 0) {
    return <div data-testid="twin-test-cut-suggestions" />
  }

  return (
    <div className="flex flex-col gap-1.5" data-testid="twin-test-cut-suggestions">
      <Text size="xs" color="muted">
        {t('threads.detail.command.suggestedCuts')}
      </Text>
      <div className="flex flex-wrap gap-1.5">
        {suggestions.map((suggestion) => {
          const isSelected = selectedSegmentBy === suggestion.key

          return (
            <button
              key={suggestion.key}
              type="button"
              data-testid={`twin-test-cut-suggestion-${suggestion.key}`}
              aria-pressed={isSelected}
              onClick={() => onChange(suggestion.key)}
              className={cn(
                'rounded-full border px-2.5 py-0.5 text-xs',
                isSelected
                  ? 'border-foreground bg-foreground text-background'
                  : 'border-border bg-background text-foreground hover:bg-muted',
              )}
            >
              {suggestion.label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
